import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { DynamicModule } from "@/components/modules/DynamicModule";

// Phase 86 — rendu d'un module sur mesure côté salarié (/salarie/modules/:key), droits appliqués par le backend.
export default function SalarieModulePage() {
  const { key } = useParams();
  const [params] = useSearchParams();
  return (
    <div className="p-6 lg:p-10 max-w-7xl" data-testid="salarie-module-page" data-module={key}>
      <DynamicModule key={key} moduleKey={key} initialEntity={params.get("entity") || undefined} />
    </div>
  );
}
